import { render, staticRenderFns } from "./PayGradeManagement.vue?vue&type=template&id=4b9c189d"
import script from "./PayGradeManagement.vue?vue&type=script&lang=js"
export * from "./PayGradeManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports